import React from "react";

const HttpClient = process.env.REACT_APP_BASE_URL;

export default HttpClient;